import { INTERVIEW_STATUS_CLASSES, INTERVIEW_STATUS_LABELS } from "./status";

export function InterviewStatusBadge({ status }: { status: string }) {
  const statusClass =
    INTERVIEW_STATUS_CLASSES[status] || "bg-[#f3f4f6] text-[#4b5563]";
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-md px-2.5 py-1 font-medium text-xs ${statusClass}`}
    >
      {INTERVIEW_STATUS_LABELS[status] || status}
    </span>
  );
}
